import { TypeRouteId } from './api';

const retoolRootUrl = 'https://xometryeu.retool.com/embedded/public';
const vatValidationUrl = () => `${retoolRootUrl}/cd24dadf-4a68-47f5-ae1d-e8cc7955c459`;
const dealOverviewUrl = () => `${retoolRootUrl}/b3153f0d-b9cd-4c12-bd36-9370763c304f`;
const retoolSharedUrl = () => `${retoolRootUrl}/b8095b5c-0d9a-4144-bbd8-7a8a309e0ab9`;
const partnerRatingUrl = () => `${retoolRootUrl}/2865c767-cbc4-4bfb-af98-c1eeeb45cc8b`;
const partnerShippingUrl = () => `${retoolRootUrl}/b8095b5c-0d9a-4144-bbd8-7a8a309e0ab9`;

const salesforceRoot = 'https://xometry-eu.lightning.force.com/lightning/r';
const salesforceCaseUrl = (caseId: TypeRouteId) => `${salesforceRoot}/Case/${caseId}/view`;
const salesforceOpportunityUrl = (opportunityId: TypeRouteId) => `${salesforceRoot}/Opportunity/${opportunityId}/view`;
const salesforceReport = (reportId: TypeRouteId) => `${salesforceRoot}/Report/${reportId}/view`;
const salesforceReportById = (reportId: TypeRouteId, fv0: TypeRouteId, region?: string) =>
  `${salesforceReport(reportId)}?fv0=${fv0}${region ? `&fv1=${region}` : ''}`;

const salesforceReportByIdSideBar = (reportId: TypeRouteId, fv0: TypeRouteId, region?: string) =>
  `${salesforceReport(reportId)}?fv0=D-${fv0}${region ? `&fv1=${region}` : ''}`;

const PNMsDashboards = () => 'https://xometry.looker.com/boards/99';

const confluenceUrl = 'https://xometry.atlassian.net/wiki';
const workspacesQuerySpec = () => `${confluenceUrl}/spaces/XomEUTech/pages/3050766461/Workspace+query+language`;

export default {
  vatValidationUrl,
  dealOverviewUrl,
  retoolSharedUrl,
  salesforceCaseUrl,
  salesforceOpportunityUrl,
  salesforceReport,
  salesforceReportById,
  salesforceReportByIdSideBar,
  partnerRatingUrl,
  partnerShippingUrl,
  PNMsDashboards,
  workspacesQuerySpec,
};
